import styled from 'styled-components';

const StyledBlockCardWrapper = styled.div<{ $isFocused: boolean }>`
  scale: ${({ $isFocused }) => ($isFocused ? 1.1 : 0.8)};
  transition: scale 0.3s;
`;

const StyledTravelMapImage = styled.img`
  max-width: 90%;
`;

export { StyledBlockCardWrapper, StyledTravelMapImage };
